<div class="container cmn-border padded cmn-flex flex row align-center gutters">
  <mat-icon  fontSet="material-icons-outlined">info</mat-icon>
  <div class="flex">{{ message }}</div>
</div>
